import { Button, Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import agreementTypes from "astrid-firestore/src/api/agreements/constants/agreementTypes";
import isApproved from "astrid-firestore/src/api/approval/isApproved";

import useHasRight from "../../../../authorization/hooks/useHasRight";
import CollectionDataTable from "../../../../ui/components/CollectionDataTable/CollectionDataTable";

import useAgreementColumns from "../../../hooks/useAgreementColumns";
import useAgreementsQuery from "../../../hooks/useAgreementsQuery";

export default function TemplateAgreements({ template }) {
	const { t } = useTranslation();

	const hasRight = useHasRight();
	const navigate = useNavigate();

	const query = useAgreementsQuery({ templateId: template.id });
	const columns = useAgreementColumns();

	const disabled = !isApproved(template) || template.deleted || template.type !== agreementTypes.FRAMEWORK;

	return (
		<>
			<Header as="h3">{t("agreements", "Agreements")}</Header>

			<Card fluid>
				<Card.Content>
					<CollectionDataTable
						query={query}
						columns={columns}
						onClick={({ id }) => navigate(`../${id}`)}
						sortBy={{
							id: "expires",
							desc: false,
						}}
					/>
				</Card.Content>

				<Card.Content>
					{hasRight("agreements.send") && (
						<Button
							color="blue"
							disabled={disabled}
							onClick={() => navigate(`../../prepare/${template.id}`)}
						>
							{t("prepareAgreements", "Prepare agreements")}
						</Button>
					)}
				</Card.Content>
			</Card>
		</>
	);
}
